import {getRegionEnum} from "../api/base/enum";
import store from "../store";
import localStorageProxy from "./listenToStorage";

/**
 * 与地区相关操作
 */
export const regionOptionKey = 'REGION_OPTIONS'
export const regionKey = 'REGION'

/**
 * 缓存地区选项
 * @param data
 */
export function setRegionOptions(data) {
  // localStorage.setItem(regionOptionKey, JSON.stringify(data))
  localStorageProxy[regionOptionKey] = JSON.stringify(data)
}

/**
 * 获取缓存地区选项
 * @return {any|*[]} 缓存地区选项
 */
export function getRegionOptions() {
  const options = localStorage.getItem(regionOptionKey)
  return options ? JSON.parse(options) : []
}

/**
 * 删除缓存地区选项
 */
export function clearRegionOptions() {
  localStorage.removeItem(regionOptionKey)
}

/**
 * 获取地区选项
 * @return {Promise<Array>}
 */
export function getRegions() {
  return new Promise((resolve, reject) => {
    getRegionEnum().then(res => {
      if (res.success) {
        const options = res.data || [];
        setRegionOptions(options)
        if (!getRegion()) {
          setRegion('us-east-1')
        }
        resolve(options)
      }
      resolve([])
    }).catch(err => {
      reject(err)
    })
  })
}


/**
 * 缓存地区
 * @param data
 */
export function setRegion(data) {
  // 使用store更新
  // store.commit('setRegion', data)
  store.commit('SET_REGION_CODE', data)
  // localStorage.setItem(regionKey, data)
  localStorageProxy[regionKey] = data
}

/**
 * 获取缓存地区
 */
export function getRegion() {
  return localStorage.getItem(regionKey)
}

/**
 * 删除缓存地区
 */
export function clearRegion() {
  localStorage.removeItem(regionKey)
}

let handleRegionChangeFun = null
export const regionMixins = {
  methods: {
    /**
     * 监听区域缓存选中变更,执行传入的函数
     * @param fun 变更后要执行的函数
     */
    listenToLocalStorageByRegion(fun) {
      handleRegionChangeFun = (e) => {
        if (e.key === regionKey) {
          fun && fun(); // 传入参数1
        }
      }; // 绑定this指向
      // 监听语言缓存
      window.addEventListener("setItemEvent", handleRegionChangeFun);
    }
  }, // 在组件销毁时执行以下代码
  beforeRouteLeave(to, from, next) {
    if (handleRegionChangeFun) {
      window.removeEventListener("setItemEvent", handleRegionChangeFun); // 取消监听事件
    }
    next();
  }
}



// WEBPACK FOOTER //
// ./src/utils/region.js